import { render, staticRenderFns } from "./FileResourceModal.vue?vue&type=template&id=dc946a9c&"
import script from "./FileResourceModal.vue?vue&type=script&lang=js&"
export * from "./FileResourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports